
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-brand text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Tagline with larger white logo */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/logo/logo.png"
                alt="AMMING"
                className="h-16 w-auto brightness-0 invert transition-transform duration-300 hover:scale-105"
              />
            </div>
            <p className="text-gray-300 leading-relaxed">
              Ihr zuverlässiger Partner im Bauwesen. Qualität und Präzision für Ihr Bauprojekt.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <nav className="space-y-2">
              <Link to="/" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Startseite
              </Link>
              <Link to="/uber-uns" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Über uns
              </Link>
              <Link to="/leistungen" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Leistungen
              </Link>
              <Link to="/referenzen" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Referenzen
              </Link>
              <Link to="/partner" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Partner
              </Link>
              <Link to="/kontakt" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Kontakt
              </Link>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Rechtliches</h3>
            <nav className="space-y-2">
              <Link to="/impressum" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="block text-gray-300 hover:text-secondary-brand transition-colors">
                Datenschutzerklärung
              </Link>
            </nav>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            <p className="text-sm md:text-base text-gray-300">&copy; 2025 AMMING GmbH. Alle Rechte vorbehalten.</p>
            <p className="text-sm md:text-base text-gray-300">
              Design und Entwicklung von{' '}
              <a 
                href="https://neunzigzehn.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-brand hover:text-white transition-colors"
              >
                neunzigzehn
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
